<template>
	<div class="reschedule_wrap">
		<div class='res_container'>
			<div class="res_head">
				<h1>Reschedule
					<span @click='close'></span>
				</h1>
			</div>
			<dl class="timeZone clearfix" v-show='!no_date'>
				<dt>
					<el-select v-model="time_zone" filterable placeholder="Time Zone">
						<el-option v-for="(key,val) in timeZone" :label="val" :value="key" :key="key">
						</el-option>
					</el-select>
				</dt>
				<dd>The {{_bookType.upper}} times listed below are presented </br> according to the time zone you selected</dd>
			</dl>
			<div class='no_time' v-show='no_date'>
				<p>Currently there are no available times. You may check our schedule availability again tomorrow, or contact your trainer for help.</p>
			</div>
			<div class="choose_time clearfix" v-show='!no_date'>
				<div class="left">
					<Calendar :show="calendar.show" :type="calendar.items.type" :value="calendar.items.value" :x="calendar.x" :y="calendar.y" :begin="calendar.items.begin" @cancel="dateCancel" @ok="dateOk" :end="calendar.items.end" :sep="calendar.items.sep" :single="calendar.items.single" :rangeValue='calendar.items.rangeValue' :autoclose='calendar.items.autoclose'>
					</Calendar>
				</div>
				<div class="right">
					<ul v-show='hasDate'>
						<li v-for='(time,idx) in time_frame' :key="idx" :class='{active:time.isActive, disable: isTimeDisable(time)}' @click='frameFn(time.work_hour_value,idx,time.work_start_time, isTimeDisable(time))'>{{time.work_start_time}}-{{time.work_end_time}}</li>
					</ul>
					<div class="no_date" v-show='!hasDate'>
						<p>No available times that day, please check other dates.</p>
					</div>
				</div>
			</div>
			<a class="submit" v-show='!no_date' @click='submit'>Submit</a>
		</div>
		<div class="shadow_pop" :style="{height:window_size.height+'px',width:window_size.width+'px'}"></div>
	</div>
</template>
<script>
/*页面相同，但逻辑不通，这是ntt的reschedule弹窗*/

import Calendar from '@common/Calendar.vue'
export default {
  props: ['timeZone', 'bookType', 'sureHandler', 'queryStatus', 'scheduledTimeZone', 'scheduledStartTime', 'scheduledEndTime'],
  data() {
    return {
      no_date: false, //选择时区后，日历时间没有true,有false
      hasDate: false, //选择时区，选择日历时间后，详细时间，没有false,有true
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '2017-03-04', // "2015-08-20"
          end: '2018-03-04',
          value: '2017-03-04',
          text: '2017-03-04',
          sep: '-',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
        }
      },
      time_zone: '',
      switch_time: '',
      time_frame: [
        /*{// 时间段
        	  'isActive':false,
		      "service_id": "2",
		      "working_date": "2017-03-26",
		      "week": "Sunday",
		      "work_hour_type": "2",
		      "work_hour_value": "1-2",
		      "work_start_time": "00:00",
		      "work_end_time": "00:30"
		    },
		    {
		      'isActive':false,
		      "service_id": "2",
		      "working_date": "2017-03-26",
		      "week": "Sunday",
		      "work_hour_type": "2",
		      "work_hour_value": "3-4",
		      "work_start_time": "01:00",
		      "work_end_time": "01:30"
		    }*/
      ],
      update_right_time: '', //右侧时间段刷新变量;因为当切换时区的时候，日期有时会相同，导致BUG出现
      chosedStartTime: ''
    }
  },
  methods: {
		isTimeDisable(time) {
      // console.log('ssssssssss', this.scheduledTimeZone, this.scheduledDate, time)

      if (!this.scheduledTimeZone || !this.time_zone) return
      if (this.scheduledTimeZone != this.time_zone) return
      if (!this.calendar.items.text || !this.scheduledStartTime || !this.scheduledEndTime) return
      if (this.calendar.items.text != this.scheduledStartTime.split(' ')[0]) return

      return this.scheduledStartTime.split(' ')[1].split(':').slice(0,2).join(':') == time.work_start_time && this.scheduledEndTime.split(' ')[1].split(':').slice(0,2).join(':') == time.work_end_time
      

      // console.log(time)
			// if (!this.scheduledTimeZone || !this.time_zone) return
			// let scheduledTimeZone = this.timeZone[this.scheduledTimeZone]
			// if (!scheduledTimeZone) return
			// if (scheduledTimeZone != this.time_zone) return

			// if (!this.scheduledDate) return
			// let [scheduled_date, scheduled_time] = this.scheduledDate.split(' ')
			// return scheduled_date === this.calendar.items.value && scheduled_time.split(":").slice(0,2).join(':') === time.name
    },
    
    close() {
      this.$store.commit('reschedule_pop_show')
    },
    // 打开显示选择器
    open(e, type) {
      // 设置类型
      this.calendar.show = true
      this.calendar.x = e.target.offsetLeft
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8
    },
    dateCancel(obj) {
      this.calendar.show = obj.show
    },
    dateOk(obj) {
      this.calendar.items.text = obj.values[0]
      this.calendar.items.value = obj.values[0]
    },
    async submit() {
      let params = new URLSearchParams()

      let date = this.calendar.items.text + ' ' + this.chosedStartTime
      if (!this.time_zone || !date || !this.time_detail) {
        this.$message.error('Please choose a training session!')
        return
      }

      let sureHandlerRes
      let isRemark

      if (this.sureHandler) {
        isRemark = this.queryStatus !== 'canceled'
        sureHandlerRes = await this.sureHandler({
          type: 'reschedule',
          isRemark
        })
      }

      params.append('timezone', this.time_zone)

      params.append('working_date', date)

      params.append('working_time', this.time_detail)

      params.append('action', this.queryStatus === 'canceled' ? 'schedule' : 'reschedule')

      if (isRemark) {
        params.append('remark', sureHandlerRes.remark)
      }

      this.axios.post(`/${this._bookType.normal}/schedule`, params).then(d => {
        if ((d.data.code == '75000')) {
          this.$message.success('Success!')
          this.$store.commit('reschedule_pop_show')
          window.location.reload()
        } else {
          this.$message.error(d.data.message)
        }
      })
    },
    frameFn(d, idx, chosedStartTime,disable) {
      if (disable) return
      
      for (var i = 0; i < this.time_frame.length; i++) {
        this.time_frame[i].isActive = false
      }
      this.time_detail = d //传入的时间段
      this.time_frame[idx].isActive = true
      this.chosedStartTime = chosedStartTime
      console.log(this.chosedStartTime)
    },
    update_right_date() {
      this.time_detail = ''
      let date = this.calendar.items.text + ' ' + this.chosedStartTime
      console.log(this.chosedStartTime)

      this.$http
        .get(
          `/${this._bookType.normal}/get${
            this._bookType.upperOne
          }Time?timezone=${this.time_zone}&working_date=${date}`
        )
        .then(
          function(response) {
            if (response.data.code == '75000') {
              this.hasDate = true
              this.time_frame = []
              for (let i = 0; i < response.data.res.length; i++) {
                let arrTime = {}
                arrTime.service_id = response.data.res[i].service_id
                arrTime.working_date = response.data.res[i].working_date
                arrTime.week = response.data.res[i].week
                arrTime.work_end_time = response.data.res[i].work_end_time
                arrTime.work_hour_type = response.data.res[i].work_hour_type
                arrTime.work_hour_value = response.data.res[i].work_hour_value
                arrTime.work_start_time = response.data.res[i].work_start_time
                arrTime.isActive = false
                this.time_frame.push(arrTime)
              }
            } else if (response.data.code == '75001') {
              this.hasDate = false
              //this.$message.error(response.data.message);
              this.time_frame = []
            } else {
              this.hasDate = false
            }
          },
          function() {
            console.log('service error')
          }
        )
    }
  },
  computed: {
    window_size() {
      return {
        width: window.outerWidth,
        height: window.outerHeight
      }
    },

    _bookType() {
      if (!this.bookType) {
        return {}
      }

      return {
        normal: this.bookType,
        upper: this.bookType.toUpperCase(),
        upperOne: this.bookType.replace(/./, e => e.toUpperCase())
      }
    }
  },
  created: function() {
    this.$http.get(`/${this._bookType.normal}/getTutorInfo`).then(d => {
      if (d.data.code == '75000') {
        let complete_status =
          d.data.res.tutor.self_study_status == 'completed' ? true : false
				let full_name = d.data.res.tutor.full_name
				let reschedule_status = d.data.res.tutor.reschedule_status
				this.time_zone = d.data.res.tutor.time_zone
				this.$emit('getTutorInfo' , d.data.res.tutor)
        console.log(complete_status)
        this.$store.commit('update_ntt_self_comlete', complete_status)
        this.$store.commit('update_full_name', full_name) //更新full_name至ntt结果页面使用
      }
    })
    //切换日期，更新时间段
    this.$watch(
      function() {
        return this.calendar.items.text
      },
      function() {
        this.update_right_date()
      }
    )
    //切换时区，更新时间段
    this.$watch(
      function() {
        return this.update_right_time
      },
      function() {
        this.update_right_date()
      }
    )
  },
  components: {
    Calendar
  },
  watch: {
    time_zone: function() {
      //切换时区，更新可选时间
      this.$http
        .get(
          `/${this._bookType.normal}/get${
            this._bookType.upperOne
          }Date?timezone=${this.time_zone}`
        )
        .then(d => {
          if (d.data.code == '75000') {
            let _this = this
            // 设置时间段
            let dates = d.data.res.cycles
            //格式化第七天的时间类型
            let serve_date =
              new Date(d.data.res.first_date).getTime() +
              (dates * 1 - 1) * 24 * 60 * 60 * 1000

            let dateEnd = new Date(serve_date)

            let year = dateEnd.getFullYear()

            let months =
              dateEnd.getMonth() + 1 < 10
                ? '0' + (dateEnd.getMonth() + 1)
                : dateEnd.getMonth() + 1

            let day =
              dateEnd.getDate() < 10
                ? '0' + dateEnd.getDate()
                : dateEnd.getDate()

            this.no_date = false

            this.calendar.items.end = year + '-' + months + '-' + day //结束时间

            this.calendar.items.begin = d.data.res.first_date //开始时间

            this.calendar.items.value = d.data.res.default_date //默认时间

            this.calendar.items.text = d.data.res.default_date //默认时间

            this.switch_time = d.data.res.switch_time

            this.update_right_time = d.data.res.switch_datetime

            this.$store.dispatch('update_switch_time', _this.switch_time)

            let date = this.calendar.items.text + ' ' + this.switch_time

            let url = `/${this._bookType.normal}/get${
              this._bookType.upperOne
            }Time?timezone=${this.time_zone}&working_date=${date}`
          } else {
            this.no_date = true
          }
        })
    }
  }
}
</script>
<style lang='less' scoped>
.reschedule_wrap {
  position: absolute;
  left: 0;
  top: 0;
  .res_container {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 736px;
    height: 588px;
    transform: translate(-50%, -50%);
    z-index: 3;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;
    .timeZone {
      height: 40px;
      margin: 25px 0 20px;
      dt {
        float: left;
        width: 338px;
      }
      dd {
        margin-left: 344px;
        line-height: 18px;
        font-size: 14px;
        padding-top: 2px;
      }
    }
    .res_head {
      height: 46px;
      line-height: 46px;
      background: #525252;
      & > h1 {
        position: relative;
        padding-left: 26px;
        font-size: 18px;
        color: #ffffff;
        span {
          position: absolute;
          right: 26px;
          top: 16px;
          width: 14px;
          height: 13px;
          background: url('~@img/close.png') no-repeat 0 0;
          cursor: pointer;
        }
      }
    }
    .no_time {
      p {
        padding: 0 50px;
        margin-top: 80px;
        line-height: 30px;
      }
    }
    .choose_time {
      height: 360px;
      background: #f7f7f7;
      & > div {
        float: left;
        width: 50%;
        height: 100%;
      }

      .left {
      }
      .right {
        padding-top: 25px;
        .no_date {
          p {
            text-align: center;
            margin-top: 20px;
          }
        }
        ul {
          overflow-y: auto;
          max-height: 292px;
          li {
            float: left;
            width: 129px;
            height: 42px;
            background: #fff;
            box-sizing: border-box;
            border: 1px solid #fcc800;
            color: #ffb400;
            border-radius: 10px;
            text-align: center;
            line-height: 42px;
            font-size: 13px;
						margin: 0 25px 25px 0;
						cursor: pointer;
						
            &.active {
              background: #fcc800;
              color: #000;
            }


						&.disable {
							color: #a9a9a9;
							border-color: #ccc;
							cursor: not-allowed;
						}
          }
          li:nth-child(odd) {
            margin-left: 21px;
          }
        }
      }
    }
    a.submit {
      width: 129px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      border: none;
      border-radius: 10px;
      font-size: 14px;
      color: #1e1e1e;
      cursor: pointer;
      background-color: #fcc800;
      display: inline-block;
      margin: 10px 0 0 578px;
    }
  }
  .shadow_pop {
    position: fixed;
    left: 0;
    top: 0;
    background: #000;
    opacity: 0.5;
    filter: alpha(opacity=50);
    z-index: 2;
  }
  .res_container {
    .el-select {
      width: 300px;
      margin: 0;
      margin-left: 25px;
    }
  }
}
</style>
<style  lang='less'>
.res_container {
  .el-select {
    width: 292px;
    height: 40px;
    margin: 30px 0 25px 25px;
    .el-input {
      input {
      }
    }
  }
}
.left {
  .calendar {
    padding: 0!Important;
    margin: 10px;
    margin-top: 155px;
    margin-left: 25px;
    border: 1px solid #cccccc;
    border-radius: 10px 10px 0 0!Important;
    overflow: hidden;
    table {
      thead {
        td {
          color: #ffb400;
        }
      }
      td {
        font-size: 13px;
        span {
          height: 39px;
          line-height: 39px;
          border-radius: 100%;
          &:hover {
            background: #fff9e5!Important;
            color: #000!Important;
          }
        }
      }
      td.selected {
        span {
          background: #fcc800;
          border-radius: 100%;
          &:hover {
            background: #fcc800;
          }
        }
      }
    }
  }
  .calendar:after {
    display: none;
  }
  .calendar:before {
    display: none;
  }
  .calendar td.selected span:hover {
  }
  div.calendar-tools {
    height: 43px;
    line-height: 43px;
    background: #525252;
    i.glyphicon-menu-left,
    i.glyphicon-menu-right {
      margin: 0 25px;
    }
    i.glyphicon-menu-left:before,
    i.glyphicon-menu-right:before {
      color: #fff;
      font-size: 14px;
    }
    & > div {
      color: #fff;
      font-size: 18px;
      cursor: normal;
    }
  }
}
</style>


// WEBPACK FOOTER //
// tpg_demo_reschedule.vue?6c0a207c